import { getAsset, AssetId } from 'owa-timestream-store';
import { useProjectId } from './useProjectId';

export default function useAssetType(assetId: AssetId) {
    const projectId = useProjectId();
    return getAsset(projectId, assetId).type;
}
